import { AI_AGENTS_MESSAGE_SCHEMA_VERSION } from "@/helpers/constants/aiAgents";

import type { MessageContent, MessageContentBlock } from "@/models/aiAgents";

export const createTextBlock = (text: string): MessageContentBlock => ({
  type: "text",
  text: text.trim(),
});

export const buildMessageContent = (
  prompt: string,
  fileBlocks: MessageContentBlock[] = []
): MessageContent => {
  const contentBlocks: MessageContentBlock[] = [];

  if (prompt.trim()) {
    contentBlocks.push(createTextBlock(prompt));
  }

  contentBlocks.push(...fileBlocks);

  return {
    version: AI_AGENTS_MESSAGE_SCHEMA_VERSION,
    content: contentBlocks,
  };
};
